import React from 'react';
import './RecentSearchChips.css';
import { useTranslation } from 'react-i18next';

export function RecentSearchChips({
  items = [],
  onSelect,
  onClear,
  isRTL = false,
  title,
}) {
  const { t } = useTranslation();
  if (!items.length) return null;

  return (
    <div className="recent-search-row" data-testid="recent-search-row">
      <div className="recent-search-header">
        <span className="recent-search-title">{title}</span>
        <button
          type="button"
          className="recent-search-clear-btn"
          onClick={onClear}
          data-testid="recent-search-clear-btn"
        >
          {t('psb.clear')}
        </button>
      </div>

      <div className={`recent-search-chips ${isRTL ? 'rtl' : 'ltr'}`}>
        {items.map((term, idx) => (
          <button
            type="button"
            key={`${term}-${idx}`}
            className="recent-search-chip"
            onClick={() => onSelect?.(term)}
            data-testid={`recent-search-chip-${idx}`}
            title={term}
          >
            {term}
          </button>
        ))}
      </div>
    </div>
  );
}

export default RecentSearchChips;
